import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["pageTitle", "metaTitle", "metaDescription", "meta"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { jsx as _jsx } from "react/jsx-runtime";
var PageHelmet = /*#__PURE__*/memo(function (_ref) {
  var pageTitle = _ref.pageTitle,
      metaTitle = _ref.metaTitle,
      metaDescription = _ref.metaDescription,
      meta = _ref.meta,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Helmet, _objectSpread({
    title: metaTitle,
    meta: [{
      name: 'description',
      content: metaDescription
    }, {
      property: 'og:title',
      content: metaTitle
    }, {
      property: 'og:description',
      content: metaDescription
    }].concat(_toConsumableArray(meta))
  }, props));
});
PageHelmet.defaultProps = {
  pageTitle: '',
  metaTitle: '',
  metaDescription: '',
  meta: []
};
export default PageHelmet;